import { PrimaryButton } from "../../../../../components/Buttons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightLong } from "@fortawesome/free-solid-svg-icons";
import { useFaunaUtils } from "../../../../../utils/faunaClient";
import { useEffect, useState } from "react";
import { faunaCollections } from "../../../../../utils/faunaCollections";
const InfrastructureDeployed = ({setNextStatus}) => {
  const {listAllForOwner} =useFaunaUtils();
  const [lastNFTCollection, setLastNFTCollection] = useState();
  
  useEffect(() => {
    const setLastNFT = async () => {
      listAllForOwner(faunaCollections.NFTCollection).then((res) => {
        if (res.length > 0) {
          setLastNFTCollection(res[res.length - 1]);
        }
      });
    };
    if (!lastNFTCollection) {
      setLastNFT();
    }
  }, [listAllForOwner, lastNFTCollection]);
  return (
    <div>
      <div className="flex flex-row min-h-screen justify-center items-center ">
        <div className="h-96 rounded overflow-hidden shadow-lg w-8/12">
          <div className="px-6 py-4">
            <div className="font-bold text-lg mb-2 text-center">
              You have successfully deployed your SaaS crypto infrastructure!
            </div>
            <div className="mb-14 mt-5">
              <div className="mb-3"></div>
              
              
              <div className="grid grid-cols-5 ">
                <div className="">
                  <img
                    className="ml-4 h-24 w-24"
                    alt="coin - fungible token"
                    src="https://5.imimg.com/data5/KM/KN/HV/SELLER-84633020/plain-gold-coin-10gm-1-500x500.jpg"
                  ></img>
                  Currency (Fungible Token)
                </div>

                <div className="pt-4">
                  <FontAwesomeIcon
                    className="ml-14 w-10 h-10"
                    onClick={() => {}}
                    icon={faArrowRightLong}
                  />
                  <div>Used to buy NFTs</div>
                </div>

                <div className="">
                  <img
                    className="ml-12 h-24 w-24"
                    alt="coin - fungible token"
                    src={lastNFTCollection?.collectionImage}
                  ></img>
                  <div className="font-bold flex justify-center">
                  {lastNFTCollection?.name} (NFT)

                  </div>
                  <div className="flex justify-center">
                  Grants Access to SaaS
                    </div>

                 
                </div>

                <div className="ml-3 pt-4">
                  <FontAwesomeIcon
                    className="ml-14 w-10 h-10"
                    onClick={() => {}}
                    icon={faArrowRightLong}
                  />
                  <div>Listed In Marketplace</div>
                </div>

                <div>
                  <div className="">
                    <img
                    className="ml-4 h-24 w-24"
                    alt="coin - fungible token"
                      src="
                      data:image/png;base64,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"
                    ></img>
                  </div>
                  Marketplace
                </div>
              </div>

              {/* <FontAwesomeIcon icon={faArrowRight} className="mr-3 h-10" /> Profile */}
            </div>


            <div className="flex justify-center mt-3">
              <PrimaryButton
              onClick={() => {
                setNextStatus()
              }}
              >Continue to test your SaaS</PrimaryButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { InfrastructureDeployed };
